import { AutoAwesome } from '@mui/icons-material';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { FormattedMessage } from 'react-intl';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import useSelectedPatient from '~/hooks/patient/useSelectedPatient';
import { primaryImageState } from '~/state/atoms/image/imageAtoms';
import { WorkflowTypes, workflowModalState } from '~/state/atoms/viewerAtoms';

interface AiAssistantButtonProps {
    page?: WorkflowTypes;
    compact?: boolean;
}

export default function AiAssistantButton({
    page,
    compact,
}: AiAssistantButtonProps) {
    const setWorkflowModal = useSetRecoilState(workflowModalState);
    const selectedPatient = useSelectedPatient();
    const primaryImage = useRecoilValue(primaryImageState);
    const isDisabled = !selectedPatient || !primaryImage;

    return (
        <Tooltip
            title={isDisabled ? <FormattedMessage id="loadImageFirst" /> : ''}
            placement="top"
        >
            {/* Wrapper needed for MUI Tooltip to work on disabled buttons */}
            <Box
                component="span"
                sx={compact ? { flex: 1, minWidth: 0 } : undefined}
            >
                <Button
                    fullWidth
                    variant="contained"
                    size={compact ? 'small' : undefined}
                    disabled={isDisabled}
                    onClick={() =>
                        setWorkflowModal((state) => ({
                            ...state,
                            open: true,
                            ...(page !== undefined && { page }),
                        }))
                    }
                    data-testid="ai-assistant-button"
                    sx={{
                        textTransform: 'capitalize',
                        borderColor: 'primary.light',
                        color: 'primary.light',
                        '&.Mui-disabled': {
                            borderColor: 'action.disabled',
                            color: 'action.disabled',
                        },
                        fontSize: 12,
                    }}
                >
                    <AutoAwesome
                        sx={{
                            position: 'absolute',
                            left: 8,
                            fontSize: 16,
                        }}
                    />
                    <FormattedMessage id="aiAssistant" />
                </Button>
            </Box>
        </Tooltip>
    );
}
